import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class EntityQueryCriteriaClass extends BaseCriteriaModel {

  
  //hdr
  name?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //ext
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  value_datetime?: Optional<string> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();
  ext_status?: Optional<string> = Optional.empty();

  //line
  line_txn_type?: Optional<string> = Optional.empty();
  entity_hdr_guid?: Optional<string> = Optional.empty();

  ext_created_date?: Optional<string> = Optional.empty();
  ext_updated_date?: Optional<string> = Optional.empty();
  entity_ext_guid?: Optional<string> = Optional.empty();
   
   

}

export class EntityCriteriaModelQuery {
  query = '';

  constructor(entityCriteriaModel: EntityQueryCriteriaClass) {
    console.log('THIS THIS', entityCriteriaModel);

    if (!entityCriteriaModel) {
      return;
    }

    this.query += entityCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += entityCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += entityCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');
    this.query += entityCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += entityCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += entityCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += entityCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += entityCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += entityCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += entityCriteriaModel.value_datetime.filter(x => x !== '').map(x => '&value_datetime=' + x).orElse('');
    this.query += entityCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += entityCriteriaModel.updated_date.filter(x => x !== '').map(x => '&updated_date=' + x).orElse('');
    this.query += entityCriteriaModel.ext_status.filter(x => x !== '').map(x => '&ext_status=' + x).orElse('');

    this.query += entityCriteriaModel.line_txn_type.filter(x => x !== '').map(x => '&line_txn_type=' + x).orElse('');
    this.query += entityCriteriaModel.entity_hdr_guid.filter(x => x !== '').map(x => '&entity_hdr_guid=' + x).orElse('');

    //new
    this.query += entityCriteriaModel.ext_created_date.filter(x => x !== '').map(x => '&ext_created_date=' + x).orElse('');
    this.query += entityCriteriaModel.ext_updated_date.filter(x => x !== '').map(x => '&ext_updated_date=' + x).orElse('');
    this.query += entityCriteriaModel.entity_ext_guid.filter(x => x !== '').map(x => '&entity_ext_guid=' + x).orElse('');

    //this.query += '&status=' + entityCriteriaModel.status;
    //this.query += '&orderBy=' + entityCriteriaModel.orderBy;
    //this.query += '&order=' + entityCriteriaModel.order;
    //this.query += '&offset=' + entityCriteriaModel.offset + '&limit=' + entityCriteriaModel.limit;
  }
}
 